import {Component, Input, OnInit} from '@angular/core';
import {SearchRequestModel} from '../../../shared/dto/search-request.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {StageChangeService} from '../../../service/stage-change.service';
import {ChangeStageFlowModel} from '../../../shared/dto/changeStageFlow.model';
import swal from 'sweetalert2';

/*
    Author - Sajith Henarath
    sajith_h@epiclanka.net
*/

@Component({
  selector: 'app-stage-change-popup',
  templateUrl: './stage-change-popup.component.html',
  styleUrls: ['./stage-change-popup.component.scss']
})
export class StageChangePopupComponent implements OnInit {
  @Input() searchRequestModalCopy: SearchRequestModel[];

  public request: any;
  public stagePopupForm: FormGroup;
  public nextWorkFlowStage: ChangeStageFlowModel;
  public nextFlowDescription: string;
  public name: string;
  public flowDescription: string;
  public flowCode: string;
  public requestId: string;
  public applicantName: string;
  public cdcNo: string;
  public href: string = "";

  constructor(public modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private stageChangeService: StageChangeService,
              private router: Router,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {

    this.loadEligibleFlow(this.flowCode);
    this.stagePopupForm = new FormGroup({
      current: new FormControl({value: this.flowDescription, disabled: true}, Validators.required),
      next: new FormControl({value: null, disabled: true}, Validators.required),
      remark: new FormControl(null, Validators.required)
    });

    this.href = this.router.url;

  }

  private loadEligibleFlow(currentStageCode: string) {
    this.stageChangeService.getNextEligibleWorkFlow(currentStageCode).subscribe(
      (response: ChangeStageFlowModel) => {
        this.nextWorkFlowStage = response;
        this.nextFlowDescription = response.description;

      }, (error) => {
        console.log('An error occurred in get next stage: ' + error);
      }
    );
  }

  onSubmit(form: FormGroup) {
    if (this.stagePopupForm.valid) {
      swal.fire({
        title: 'Are you sure, you want to submit?',
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: 'Update'
      }).then((result) => {
        if (result.value) {
          const dto: ChangeStageFlowModel = new ChangeStageFlowModel(
            this.flowCode,
            this.flowDescription,
            this.nextWorkFlowStage.nextWorkFlowCode,
            form.value.remark,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );

          this.stageChangeService.updateWorkFlowofApplicant(dto, this.requestId).subscribe(
            (response: string) => {
              swal.fire("Success", "Details updated successfully", "success");
            }, (error) => {
              swal.fire("Sorry!", "Something went wrong...!", "error");
            }, () => {
              this.activeModal.close("Updated");
            }
          );
        }

      });
    } else {
      swal.fire("Remark required!", "Fill the remark to continue", "warning");
    }
  }

}

